<template v-if="currentRoute == 'live'">
	<div  class="qna-widget">
		<!-- body -->
		<question-list></question-list>
		<qna-actions></qna-actions>
	</div>
</template>

<template v-if="currentRoute == 'embed'" class="qna-widget">
	<div  class="qna-widget">
		<!-- body -->
		<qna-actions></qna-actions>
		<question-list></question-list>
	</div>
</template>

<script>
	import {
  	mapState,
  	mapGetters,
  	mapActions
	} from 'vuex'

	import QuestionList from '@/components/qna/QuestionList.vue'
	import QnaActions from '@/components/qna/QnaActions.vue'

	export default {
		data () {
			return {}
		},
		components: {
			QuestionList,
			QnaActions
		},
		computed: {
			...mapGetters('webcast', {
				webcast: 'getCopy',
			}),
			currentRoute(){
				return this.$router.currentRoute.name;
			}
		},

		methods: {
			...mapActions('qna', {
      	questionList: 'find',
      	createQuestionAction: 'create',
      	patchQuestionAction: 'patch'
    	}),


			/*
    	changePersonInfoEditing (isEdit) {
    		this.editingPersonInfo = isEdit
    	},

    	toggleQuestionField (state) {
				if(state=='focus'){
					this.$set(this.$data, 'newQuestionRows', 3);
					this.newQuestionExpanded = true;
				} else{
					this.$set(this.$data, 'newQuestionRows', 1);
					this.newQuestionExpanded = false	;
				}
    	},

    	updatePersonInfo () {
    		this.changePersonInfoEditing(false)
    	},

    	setPersonInfo () {
    		if (!_.isEmpty(this.registration)) {
    			this.personInfo.name = this.registration.name
    			this.personInfo.location = this.registration.location
				}
    	},



			clearQuestionInput(){
				this.toggleQuestionField('blur');
				this.newQuestion = '';
			},

    	createNewQuestion () {
    		let data = {
    			webcastId: this.webcastId,
    			name: this.personInfo.name,
    			location: this.personInfo.location,
    			text: this.newQuestion,
    			bucket: 'inbox',
    			isAnswered: false,
    			isApproved: !this.webcast.qnaModeration
    		}

	      if (data.text) {
	      	this.createQuestionAction(data)
	      	.finally(() => {
	      		this.scrollToListBottom()
	      		this.newQuestion = ''
	      		this.toggleQuestionField('blur')
	      	})
	      }
			 }
			 */
		},

		created () {
			//this.setPersonInfo()
  	}
	}
</script>

<style>

</style>
<style lang="scss" scoped>

	.qna-widget{
		height: 100%;
    background-color: #fff;
	}

	.actions {
		border-top: 0.5px solid #e9eaec;
		padding: 15px;
		position: relative;
		bottom: 103px;
    width: 100%;
		background: #fff;

		&--new-question {
			bottom: 205px;
			//height: calc(100vh - (86px + 64px));
			textarea.ivu-input{
				height: 3em !important;
			}
		}

		&--editing {
			bottom: 265px;
			@media screen and (max-width: 992px) {
				bottom: 225px;
			}
		}



		&-header {
			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;
			align-items: center;
			padding: 0;
		}
	}

	.qna {
		&-action {
			&-change {
				font-weight: normal;
				font-size: 12px;
				text-transform: inherit;
				padding: 0;
				color: #337AB7;
				&:focus {
					box-shadow: none;
				}
			}
		}

		&-name {
			color: #367DB8;
			&--action {
				font-size: 14px;
				font-weight: bold;
				color: #373C46;
			}
		}

		&-location {
			color: #808695;
			&--action {
				font-size: 14px;
				color: #777777;
			}
		}
	}

	.new-question {
		width: 100%;

		&--submit {
			margin-top:16px;
			margin-right:8px;
			float: right;
		}
	}


	.edit-person-info {
		padding-top: 15px;
	}

	/*
	@media screen and (max-width: 992px) {
		.actions-header {
			padding: 10px 0;
		}

		.qna-widget{
			height: 100%;
		}

		.ivu-input {
			font-size: 11px;
		}

		.body {

			&--editing {
				display: none;
				& + .actions {
					border: none;
					.edit-person-info {
						padding-top: 0;
					}
				}
			}


		}
	}
	*/
</style>
